var vipCallback = function( mutationsList ) {

    mutationsList.forEach(mutation => {

        if ( mutation.type == 'childList' ) {

            mutation.addedNodes.forEach( element => {

                if (element.nodeType === 1 && element.classList.contains('vip-message')) {
                    const suggestPanel = document.getElementById('suggestPanel');

                    if (suggestPanel) {

                        suggestPanel.style.display = 'none';

                    }
                }

            });

            mutation.removedNodes.forEach( element => {

                if (element.nodeType === 1 && element.classList.contains('vip-message')) {
                    const suggestPanel = document.getElementById('suggestPanel');

                    if (suggestPanel) {

                        suggestPanel.style.display = 'block';

                    }
                }

            });
            // console.log('A child node has been added or removed.', mutation);
        }

    });
};

export default vipCallback;